import { useDispatch } from "react-redux";
import { STRING_SUB_MENU } from "../../../constants/string";
import { toggleMenuContent } from "../../../store/themeConfigSlice";
import { useEffect, useState } from "react";
import { ACTION_TYPE } from "../../../constants/action-enum";
import { useFetchData } from "../../../hooks/useFetch";
import { API_PROMOTION_CAMPAIGN_TYPES_ROUTER, ApiConfig } from "../../../services/api-config";
import { showToast } from "../../../components/custom/custom-toast";
import { PAGE_SIZES } from "../../../constants/status";
import { PromotionCampaign } from "../../../models/response/promotion-campaign";
import { BasePaginateResponse } from "../../../services/base-response";
import PromotionCampaignTable from "../components/promotion-campaign-type-table";
import { PromotionCampaignActionsModal } from "../components/promotion-campaign-type-actions-modal";

export const PromotionCampaignTypePage = () => {
  const dispatch = useDispatch();
  dispatch(toggleMenuContent(STRING_SUB_MENU.PROMOTION_CAMPAIGN_TYPE));

  const [isOpen, setIsOpen] = useState(false);
  const [selectedPromotionCampaign, setSelectedPromotionCampaign] = useState<PromotionCampaign>(new PromotionCampaign());
  const [promotionCampaigns, setPromotionCampaigns] = useState<PromotionCampaign[]>([]);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(PAGE_SIZES[0]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [keySearch, setKeySearch] = useState("");

  const { request: getPromotionsCampaign, baseResponse: promotionsCampaignRes, loading: tableLoading } = useFetchData.Get<BasePaginateResponse<PromotionCampaign[]>>({ projectId: ApiConfig.PROJECT_ID.USER_SERVICE });

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        page,
        limit,
        key_search: keySearch,
        type: '-1'
      };
      await getPromotionsCampaign({
        endPoint: API_PROMOTION_CAMPAIGN_TYPES_ROUTER.API_GET_PROMOTION_CAMPAIGNS(),
        data: params,
      });
    };

    fetchData();
  }, [page, limit, keySearch]);

  useEffect(() => {
    if (!promotionsCampaignRes) return;
    if (promotionsCampaignRes?.data && promotionsCampaignRes?.status === 200) {
      setPromotionCampaigns(promotionsCampaignRes.data.list);
      setTotalRecords(promotionsCampaignRes.data.total_record);
    } else {
      showToast({
        message: promotionsCampaignRes?.message ?? "Không thể tải danh sách khuyến mãi",
        type: "error",
      });
    }
  }, [promotionsCampaignRes]);

  const handleActionTypeChange = (actionType: ACTION_TYPE, item?: PromotionCampaign) => {
    setIsOpen(true);
    if (item && (actionType === ACTION_TYPE.EDIT || actionType === ACTION_TYPE.DETAIL || actionType === ACTION_TYPE.STATUS)) {
      setSelectedPromotionCampaign(item);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <PromotionCampaignTable
        tableLoading={tableLoading}
        data={promotionCampaigns ?? []}
        totalRecords={totalRecords}
        keySearch={keySearch}
        setKeySearch={setKeySearch}
        page={page}
        setPage={setPage}
        pageSize={limit}
        setPageSize={setLimit}
        handleActionTypeChange={handleActionTypeChange}
      />

      <PromotionCampaignActionsModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        item={selectedPromotionCampaign}
      />
    </div>
  );
};
